module.exports = __webpack_public_path__ + "static/media/group-3.8b0e49ce.svg";